import React, {useState} from 'react';
import {Link, Navigate} from 'react-router-dom';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {login} from '../../Redux/actions/authAction';
import styled from "styled-components";
import {RiLock2Line, RiMailLine} from "react-icons/ri";
import Logo from "../layout/Logo";

const Login = ({login, isAuthenticated}) => {
    const [formData, setFormData] = useState({
        email: '',
        password: '',
    });

    const {email, password} = formData;

    const onChange = (e) =>
        setFormData({...formData, [e.target.name]: e.target.value});

    const onSubmit = async (e) => {
        e.preventDefault();
        login(email, password);
    };

    // Redirect if logged in
    if (isAuthenticated) {
        return <Navigate to='/'/>;
    }

    return (
        <Container>
            <div className='login-container content-center'>
                <div className="flex-container">
                    <div className='text-center'>
                        <Logo full={true}/>
                        <h3 style={{paddingBottom: '1rem', paddingTop: '3rem'}}>Sign in</h3>
                        <p style={{paddingBottom: '2rem'}}>Sign in to continue to  FM Messenger.</p>
                    </div>
                    <div className='box'>
                        <form className='form' onSubmit={(e) => onSubmit(e)}>
                            <div className='form-group'>
                                <label className="form-label">Email</label>
                                <div className='form-input-container'>
                                    <RiMailLine className='form-input-icon'/>
                                    <input
                                        className='form-input'
                                        type='email'
                                        placeholder='Enter Email Address'
                                        name='email'
                                        value={email}
                                        onChange={(e) => onChange(e)}
                                        autoComplete="on"
                                        required
                                    />
                                </div>
                            </div>
                            <div className='form-group'>
                                <label className="form-label">Password</label>

                                <div className='form-input-container'>
                                    <RiLock2Line className='form-input-icon'/>
                                    <input
                                        className='form-input'
                                        type='password'
                                        placeholder='Password'
                                        name='password'
                                        value={password}
                                        onChange={(e) => onChange(e)}
                                        minLength='6'
                                        autoComplete="on"
                                    />
                                </div>
                            </div>

                            <input type='submit' className='sign-button' value='Sign in'/>
                        </form>
                    </div>

                    <div className='text-center text-decoration-none'>
                        <p style={{paddingBottom: '1rem'}}> Don't have an account ?
                            <Link to='/register'> Sign up now</Link>
                        </p>
                        <p>© 2022  FM Messenger. Developed by
                            <a href='https://fmcv.ir' target="_blank" rel="noreferrer"> Fmcv.ir</a>
                        </p>
                    </div>
                </div>
            </div>
        </Container>
    );
};

Login.propTypes = {
    login: PropTypes.func.isRequired,
    isAuthenticated: PropTypes.bool,
};

const mapStateToProps = (state) => ({
    isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, {login})(Login);

const Container = styled.div`
  margin-top: 3rem;
  margin-bottom: 3rem;
  padding: 3rem 3rem;

  @media (max-width: 575px) {
    margin-top: 1rem;
    padding: 1rem 0;
  }

  .login-container {
    width: 100%;
  }

  .content-center {
    display: flex;
    justify-content: center;
  }

  .flex-container {
    max-width: 500px;
    width: 80%;

    @media (max-width: 575px) {
      width: 100%;
    }
  }

  .text-center {
    text-align: center ;
  }

  .box {
    padding: 2.5rem;
    background-color: white;
    position: relative;
    display: flex;
    flex-direction: column;
    word-wrap: break-word;
    background-color: white;
    background-clip: border-box;
    border: 0 solid #f5f7fb;
    border-radius: 0.25rem;
    margin-bottom: 3rem;
  }

  .form-group {
    margin-bottom: 1rem;
    position: relative;
    flex-direction: column;
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    width: 100%;
  }

  .form-label {
    display: block;
    margin-bottom: 0.5rem;
  }

  .form-input-container {
    position: relative;
    display: flex;
  }

  .form-input-icon {
    color: #7a7f9a;
    padding: 0.7rem 1rem;
    font-size: 1.2rem;
    line-height: 1.5;
    white-space: nowrap;
    background-color: #f5f7fb;
    border: 1px solid #e6ebf5;
    border-bottom-left-radius: 0.25rem;
    border-top-left-radius: 0.25rem;
  }

  .form-input {
    width: 100%;
    margin-left: -1px;
    padding: 0.5rem 1rem;
    font-size: .875rem;
    font-weight: 400;
    line-height: 1.5;
    color: #7a7f9a;
    background-color: #f5f7fb;
    border: 1px solid #e6ebf5;
    border-bottom-right-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
  }

  .text-decoration-none {
    a {
      text-decoration: none
    }
  }

  .sign-button {
    width: 100%;
    margin-top: 1rem;
    cursor: pointer;
    color: #fff;
    background-color: #7269ef;
    line-height: 1.5;
    padding: 0.65rem 1rem;
    border-radius: 0.25rem;
    border: none;
    transition: 0.25s;
    font-size: 0.9rem;

    :hover {
      background-color: #6159cb;
      border-color: #5b54bf;
    }
  }
`;